export interface Experience {
  role: string;
  company: string;
  period: string;
  bullets: string[];
  techstack: string[];
}

export const experience: Experience[] = [
  {
    role: "Full Stack Developer",
    company: "TradePoints Pty Limited",
    period: "Feb 2026 — Present",
    bullets: [
      "Developed and maintained scalable full-stack web applications for a rewards and trading platform serving multiple user portals including Admin, Member, Merchant, and Reward Partner systems.",
      "Designed and implemented RESTful APIs and backend services using NestJS, TypeScript, and PostgreSQL, supporting rewards management, wallet transactions, order processing, and merchant integrations.",
      "Built responsive and interactive frontend applications using React, TypeScript, Redux Saga, and Tailwind CSS, enhancing user experience and platform usability.",
      "Led the integration of third-party reward providers and external APIs, including automated synchronization processes, reward catalog management, and country-based restrictions.",
      "Implemented CI/CD pipelines and cloud deployment workflows using GitHub Actions, Docker, AWS EC2, ECR, CloudFront, Route 53, and SSM for automated deployments and infrastructure management.",
      "Optimized database queries and application performance through TypeORM query tuning, indexing strategies, caching approaches, and backend refactoring.",
    ],
    techstack: [
      "TypeScript",
      "React",
      "Redux Saga",
      "Tailwind CSS",
      "NestJS",
      "Node.js",
      "PostgreSQL",
      "TypeORM",
      "AWS",
      "Docker",
      "GitHub Actions",
      "CloudFront",
      "Route 53",
      "EC2",
      "ECR",
      "SSM",
      "REST API",
      "CI/CD",
      "Git",
    ],
  },
  {
    role: "Senior Software Engineer",
    company: "Enactor Limited",
    period: "Dec 2023 — Feb 2024",
    bullets: [
      "Served as the Development Team Lead for the Portugal Fiscal Team, leading efforts to implement fiscalization processes following Portugal Tax Authority requirements.",
      "Successfully obtained the Portugal Tax Authority Certification for our POS system, Enactor POS.",
      "Conducted training sessions for junior team members, facilitating the transfer of knowledge and expertise.",
      "Played a pivotal role in enhancing junior team members' skill sets and capabilities.",
      "Conducted code reviews and collaboration within the development team to ensure code quality and adherence to coding standards.",
      "Authored and maintained technical and functional specifications, providing clear documentation for both internal development teams and external clients.",
    ],
    techstack: [
      "Java",
      "React",
      "XML",
      "MySQL",
      "Socket.io",
      "Jenkins",
      "SVN",
      "Jira",
      "Confluence",
      "TestNG",
      "Cucumber",
      "Technical Specs",
      "Code Review",
    ],
  },
  {
    role: "Software Engineer",
    company: "Enactor Limited",
    period: "May 2022 — Nov 2023",
    bullets: [
      "Led the implementation of Hungary's fiscalization details gathering, playing a key role in collecting and documenting essential information for the successful execution of fiscalization processes.",
      "Successfully integrated a testing API to communicate with the Hungary Fiscal Printer, ensuring seamless interaction and functionality testing.",
      "Took charge of the integration of a new fiscal printer in Italy, aligning with project specifications and ensuring compatibility with existing systems.",
      "Implemented fiscal functionalities according to function specifications, contributing to the enhancement of our product's capabilities.",
      "Addressed and resolved software bugs in Austria and Poland, ensuring the stability and reliability of the software in these regions.",
      "Implemented fiscal functionalities following Turkey's legal fiscal requirements and technical specifications and played a crucial role in ensuring compliance with Turkey's fiscal regulations.",
      "Collaborated with the certification team for France, actively contributing to the implementation of fiscalization processes to meet the requirements for obtaining the France Tax Authority certification.",
      "Spearheaded the development of automated tests using Cucumber for both Turkey and Portugal's Fiscalization processes.",
      "Contributed to Java unit testing using TestNG for Portugal, Turkey, and common Java actions within the Enactor Platform.",
      "Implemented new ReactJS pages for Enactor React POS in Portugal and Turkey.",
    ],
    techstack: [
      "Java",
      "React",
      "XML",
      "MySQL",
      "Socket.io",
      "Jenkins",
      "SVN",
      "Jira",
      "Confluence",
      "TestNG",
      "Cucumber",
    ],
  },
  {
    role: "Software Developer",
    company: "Ikon Marketing",
    period: "Jun 2020 — May 2022",
    bullets: [
      "Worked as a lead developer with a team of five members and developed custom solutions on demand for secondary clients.",
      "Finance Houses Association Website - Developed the website & dashboard for the 'FHA'. Contributed to user management and authentication process.",
      "Jewelry E-Commerce Platform - Developed the website & dashboard for the 'Roux and Glamour'.",
      "Gem Certification Platform - Certificate Generation Platform for 'Serendip Gem Testing Lab' to generate certificates with QR back-links.",
    ],
    techstack: [
      "Angular",
      "NodeJs",
      "ExpressJs",
      "JavaScript",
      "TypeScript",
      "JWT",
      "Firebase",
      "GCP",
      "MongoDB",
      "Serverless",
      "Bootstrap",
      "CSS",
      "SASS",
      "Cloud Functions",
      "Heroku",
      "AWS S3",
      "GitHub",
    ],
  },
  {
    role: "Software Engineer",
    company: "Fcode Labs (PVT) Limited",
    period: "Jun 2021 — Oct 2021",
    bullets: [
      "Worked as a Full-stack developer for customized software solutions for foreign clients.",
      "Fortify Asia - A web application for connecting ideas and projects to experts all across Asia.",
      "Project GIS - A web application to convert GeoJsons to Georss.",
    ],
    techstack: [
      "React",
      "NestJs",
      "TypeScript",
      "JavaScript",
      "NodeJs",
      "Firebase",
      "MongoDB",
      "GIS",
      "Cloud Functions",
      "GitHub",
    ],
  },
  {
    role: "Software Engineer Intern",
    company: "Fcode Labs (PVT) Limited",
    period: "Oct 2020 — May 2021",
    bullets: [
      "Contributed as a web and mobile developer.",
      "Flingo - A real-time chat Application. Implemented block user functionality and fixed bugs.",
      "Drawing Gif - A Mobile Application to make Memes and GIFs. Published in the Play Store, Appstore, and Huawei store.",
      "Open Home - A real estate web application. Contributed to implementing the backend.",
      "MAS ALT-IT - A Mobile Application for MAS Holdings to manage fittings.",
      "Flingo - A real-time chat Application. Implemented block user functionality and fixed bugs.",
    ],
    techstack: [
      "Flutter",
      "Firebase",
      "Java",
      "SpringBoot",
      "TypeScript",
      "Bloc",
      "Microservices",
    ],
  },
];
